import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import {
  addStudentInClass,
  addStudentInEvent,
  saveClassAttendance,
  saveEventAttendance,
} from "../../api/register";
import Loader from "../../component/Loader";
import { useToggle } from "../../utils/hooks";
import AddNewStudent from "./AddNewStudent";
import {
  changeLevel,
  detail,
  FetchAllOtherStudents,
  FetchAllOtherStudentsForEvent,
  FetchAllStudentsForClass,
  FetchAllStudentsForEvent,
  FetchRegisterDetail,
} from "./RegisterSlice";
import ReactToPrint from "react-to-print";
import PrintComponent from "../../component/print/PrintComponent";
import PrintEventComponent from "../../component/print/PrintEventComponent";
import ChangeStudentClass from "../../component/Modal/ChangeStudentClass";
import { cancelClass, changeStudentClass } from "../../api/class";
import BackButton from "./../../component/BackButton";
import Select from "react-select";
import Cancel from "../../component/Modal/Cancel";
import { BiSort } from "react-icons/bi";
import ChangeStudentEventComponent from "../../component/Modal/ChangeStudentEvent";

const style = {
  control: (styles) => ({
    ...styles,
    // none of react-select's styles are passed to <Control />
    borderWidth: 0,

    "&:hover": {
      borderColor: "transparent",
      outline: "0",
      boxShadow: "none",
    },
  }),
  container: (styles) => ({
    ...styles,
    // none of react-select's styles are passed to <Control />
    backgroundImage: "none",
    paddingRight: "2px",
    borderRadius: "10px",
  }),
};

function ViewRegister() {
  const { id } = useParams();
  const data = useSelector((state) => state.register.details);

  const studentForClass = useSelector(
    (state) => state.register.otherStudentsListForClass
  );
  const studentForEvent = useSelector(
    (state) => state.register.otherStudentsListForEvents
  );
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [filteredTimeSlots, setFilteredTimeSlots] = useState([]);
  const [allTimeSlots, setAllTimeSlots] = useState([]);
  const [show, toggle] = useToggle(false);
  const dispatch = useDispatch();
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState("all");
  const register_for = useSelector((state) => state.register.register_for);
  const allStudentForClass = useSelector(
    (state) => state.register.allStudentForClass
  );
  const allStudentForEvent = useSelector(
    (state) => state.register.allStudentForEvent
  );
  //const levelId = localStorage.getItem("level") || "";// useSelector((state) => state.register.level);
  const [levelId, SetLevelId] = useState(localStorage.getItem("level"));
  //const levelId = useSelector((state) => state.register.level);
  const [changeClassForStudentData, setChangeClassForStudentData] =
    useState(null);
  const [showClass, handleShow] = useToggle(false);
  const [showCancelClassModal, setShowCancelClassModal] = useState(false);
  const navigate = useNavigate();
  const [cancelClassDetail, setCancelClassDetail] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [changeClassSubmitting, setChangeClassSubmitting] = useState(false);
  const [addStudentSubmitting, setAddStudentSubmitting] = useState(false);
  const [changeEventForStudentData, setChangeEventForStudentData] =
    useState(null);
  const [changeEventSubmitting, setChangeEventSubmitting] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: "first_name",
    direction: "ascending",
  });

  const getDetails = useCallback(() => {
    setLoading(true);
    dispatch(
      FetchRegisterDetail({
        classId: register_for === "class" ? id : "",
        eventId: register_for === "event" ? id : "",
        register_for: register_for,
        date: register_for === "event" ? date : date?.date,
        time: register_for === "event" ? time : "",
        start_time: register_for === "class" ? time.start_time : "",
        end_time: register_for === "class" ? time.end_time : "",
        levelId: levelId,
      })
    ).then((res) => {
      setLoading(false);
      if (res?.payload?.code === 1) {
        if (
          register_for === "event" &&
          res?.payload?.data?.register_details?.levels?.length > 0 &&
          !levelId
        ) {
          (async () => {
            await localStorage.setItem(
              "level",
              res?.payload?.data?.register_details?.levels?.[0]?.id
                ? res?.payload?.data?.register_details?.levels?.[0]?.id
                : ""
            );
          })();

          dispatch(
            changeLevel(
              res?.payload?.data?.register_details?.levels?.[0]?.id
                ? res?.payload?.data?.register_details?.levels?.[0]?.id
                : ""
            )
          );
        }
        // Store all time slots with dates for combined dropdown
        var allTimeSlotsWithDates = res?.payload?.data?.register_details?.time_slot
          ?.filter((it) => it?.isCancelled === false)
          ?.map((value) => {
            return {
              available_seats: value?.available_seats,
              start_time: value?.start_time,
              end_time: value?.end_time,
              time_slot_id: value?.time_slot_id,
              date: value?.date,
            };
          })
          .sort(function (a, b) {
            return new Date(a.date + ' ' + a.start_time) - new Date(b.date + ' ' + b.start_time);
          });

        var times = allTimeSlotsWithDates
          ?.filter(
            (value, index, _arr) =>
              _arr.findIndex(
                (it) =>
                  it?.start_time === value.start_time &&
                  it?.end_time === value.end_time &&
                  it?.time_slot_id === value?.time_slot_id
              ) === index
          );

        var days = res?.payload?.data?.register_details?.time_slot
          ?.filter((it) => it?.isCancelled === false)
          ?.map((value) => {
            return { ...value, date: value.date };
          })
          ?.filter(
            (value, index, _arr) =>
              _arr.findIndex(
                (it) => it?.date?.toString() === value?.date?.toString()
              ) === index
          )
          ?.sort(function (a, b) {
            return new Date(a.date) - new Date(b.date);
          });
        console.log(days, times, "Days and time");

        setAllTimeSlots(allTimeSlotsWithDates || []);
        setAvailableTimeSlots(times);
        setAvailableDates(days);
        setFilteredTimeSlots([]);
        if (register_for === "event") {
          if (!date && !time) {
            setDate(res?.payload?.data?.register_details?.date);
            setTime(res?.payload?.data?.register_details?.start_time);
          }
        }
      }
    });
  }, [dispatch, id, date, time, register_for, levelId]);

  useEffect(() => {
    getDetails();
  }, [getDetails]);

  // Auto-select nearest time slot for class on initial load
  useEffect(() => {
    console.log("Auto-select effect running:", {
      register_for,
      allTimeSlotsLength: allTimeSlots?.length,
      time,
      date,
      timeType: typeof time,
      dateType: typeof date
    });
    
    if (register_for === "class" && allTimeSlots?.length > 0 && time === "" && date === "") {
      // Find the nearest time slot to current date/time
      const now = new Date();
      const nearestSlot = allTimeSlots.find((slot) => {
        const slotDateTime = new Date(slot.date + ' ' + slot.start_time);
        return slotDateTime >= now;
      }) || allTimeSlots[0];
      
      if (nearestSlot) {
        console.log("Auto-selecting nearest slot:", nearestSlot);
        setTime(nearestSlot);
        setDate(nearestSlot);
      }
    }
  }, [allTimeSlots, register_for, time, date]);

  const getStudentListing = useCallback(() => {
    if (register_for === "class") {
      console.log("Class student running");
      dispatch(FetchAllOtherStudents(id));
    } else if (register_for === "event") {
      console.log("Event student running");
      dispatch(FetchAllOtherStudentsForEvent(id));
    }
  }, [dispatch, id, register_for]);

  useEffect(() => {
    getStudentListing();
  }, [getStudentListing]);

  useEffect(() => {
    return () => {
      dispatch(detail(null));
    };
  }, [dispatch]);
  // working forclass
  const StudentAttendance = ({ dataa, status }) => {
    console.log(dataa, status, date, time, "Save student");
    if (register_for === "class") {
      const payload = {
        studentId: dataa?.id,
        classId: id,
        date: date.date,
        start_time: time?.start_time,
        end_time: time?.end_time,
        status: status,
        time_slot_id: date?.time_slot_id,
      };
      if (date && time) {
        saveClassAttendance(payload).then((res) => {
          if (res?.code === 1) {
            toast.success(res?.message);
            getDetails();
          } else {
            toast.error(res?.message, {  autoClose: false,  closeButton: true});
          }
        });
      } else {
        toast.error("Kindly select a date and time.", {  autoClose: false,  closeButton: true});
      }
    } else {
      const payload = {
        studentId: dataa?.id,
        eventId: id,
        teacherId: data?.teacher_details?.id || "",
        date: date,
        levelId: levelId || "",
        status: status,
      };
      if (date && time) {
        saveEventAttendance(payload).then((res) => {
          if (res?.code === 1) {
            toast.success(res?.message);
            getDetails();
          } else {
            toast.error(res?.message, {  autoClose: false,  closeButton: true});
          }
        });
      } else {
        toast.error("Kindly select a date and time.", {  autoClose: false,  closeButton: true});
      }
    }
  };

  // const fetchDetails = useCallback(() => {
  //   dispatch(
  //     FetchRegisterDetail({
  //       classId: register_for === "class" ? id : "",
  //       eventId: register_for === "event" ? id : "",
  //       register_for: register_for,
  //       date: date,
  //       start_time: time,
  //       levelId: levelId,
  //     })
  //   );
  // }, [dispatch, date, time, levelId, register_for, id]);

  // useEffect(() => {
  //   fetchDetails();
  // }, [fetchDetails]);

  const addStudentToRegister = (student, _time, _date, _class_type) => {
    console.log(
      data,
      _date,
      student,
      _time,
      _class_type,
      "Inside add student register"
    );
    setAddStudentSubmitting(true);

    if (register_for === "class") {
      const payload = {
        userId: student?.userId,
        total_amount:
          String(student?.trialAccountStatus) === "1"
            ? student?.student_type?.toLowerCase() === "child" && data?.free_class_charge
              ? data?.free_class_charge
              : student?.student_type?.toLowerCase() === "adult" && data?.free_class_charge_adult
              ? data?.free_class_charge_adult
              : 0
            : student?.student_type?.toLowerCase() === "child" && data?.child_price
            ? data?.child_price
            : student?.student_type?.toLowerCase() === "adult" &&
              data?.adult_price
            ? data?.adult_price
            : 0,
        schoolId: data?.schoolId,
        classId: id,
        teacherId: data?.assigned_teacher?.teacher_details?.id,
        child_price: data?.child_price,
        adult_price: data?.adult_price,
        free_class_charge: data?.free_class_charge,
        free_class_charge_adult: data?.free_class_charge_adult,
        date: _date.date,
        start_time: _time.start_time,
        end_time: _time.end_time,
        time_slot_for: student?.student_type,
        time_slot_id: _time?.time_slot_id,
        studentId: student?.id,
        student_type: student?.student_type,
        trialAccountStatus: student?.trialAccountStatus,
        addedBy: "ADMIN"
      };
      // if (
      //   _time?.available_seats > 0 &&
      //   _time?.available_seats <= data?.total_seats
      // ) {
        addStudentInClass(payload)
          .then((res) => {
            if (res?.code === 1) {
              if (res?.message?.toLowerCase()?.includes("already added")) {
                toast.error(res?.message, {  autoClose: false,  closeButton: true});
              } else {
                toast.success(res?.message);
              }
            } else {
              toast.error(res?.message, {  autoClose: false,  closeButton: true});
            }
            return res;
          })
          .then((response) => {
            if (response?.code === 1) {
              if (
                !response?.message
                  ?.toLowerCase()
                  ?.includes("student already added to the class.")
              ) {
                getDetails();
                toggle();
              } else {
              }
            }
          })
          .then(() => {
            setAddStudentSubmitting(false);
          });
      // } else {
      //   toast.error("Sorry, all the seats in this class are taken.");
      // }
    } else if (register_for === "event") {
      const payload = {
        schoolId: data?.schoolId,
        eventId: id,
        levelId: data?.level_details?.id || "",
        date: data?.date,
        area: data?.areacode_details?.id,
        age_group: data?.age_group || "",
        teacherId: data?.teacher_details?.id || "",
        price:
          data?.level_details && student?.student_type === "child"
            ? data?.level_details?.child_price
            : data?.level_details && student?.student_type === "adult"
            ? data?.level_details?.adult_price
            : !data?.level_details && student?.student_type === "child"
            ? data?.child_price
            : !data?.level_details && student?.student_type === "adult"
            ? data?.adult_price
            : "",
        studentId: student?.id,
        trialAccountStatus: student?.trialAccountStatus,
        userId: student?.userId,
        total_amount:
          student?.student_type === "child" && data?.level_details
            ? data?.level_details?.child_price
            : student?.student_type === "adult" && data?.level_details
            ? data?.level_details?.adult_price
            : student?.student_type === "child"
            ? data?.child_price
            : student?.student_type === "adult"
            ? data?.adult_price
            : 0,
      };
      addStudentInEvent(payload)
        .then((res) => {
          if (res?.code === 1) {
            if (res?.message?.toLowerCase()?.includes("already added")) {
              toast.error(res?.message, {  autoClose: false,  closeButton: true});
            } else {
              toast.success(res?.message);
            }
          } else {
            toast.error(res?.message, {  autoClose: false,  closeButton: true});
          }
          return res;
        })
        .then((response) => {
          if (response?.code === 1) {
            if (
              !response?.message
                ?.toLowerCase()
                ?.includes("student already added to the class.")
            ) {
              getDetails();
              toggle();
            } else {
            }
          }
        })
        .then(() => {
          setAddStudentSubmitting(false);
        });
    }
  };

  const handleChangeClass = (data) => {
    setChangeClassSubmitting(true);
    changeStudentClass(data).then((res) => {
      setChangeClassSubmitting(false);
      if (res?.code === 1) {
        toast.success(res?.message);
        getDetails();
        handleShow();
        setChangeClassForStudentData(null);
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  const isCancelledClass = useCallback(() => {
    let arr = data?.time_slot?.filter(
      (it) =>
        it?.date === date?.date &&
        it?.start_time === time?.start_time &&
        it?.end_time === time?.end_time
    );
    console.log(arr?.[0]?.isCancelled);

    return arr?.[0]?.isCancelled;
  }, [data, date?.date, time?.start_time, time?.end_time]);

  useEffect(() => {
    isCancelledClass();
  }, [isCancelledClass]);

  const handleCancelClass = (reason) => {
    setSubmitting(true);
    console.log(reason, "Reason");

    let arr = data?.time_slot?.filter(
      (it) =>
        it?.date === date?.date &&
        it?.start_time === time?.start_time &&
        it?.end_time === time?.end_time
    );
    const time_slot_id = arr?.[0]?.time_slot_id;
    console.log(arr);

    cancelClass({
      classId: id,
      time_slot_id,
      date: moment(date?.date).format("YYYY-MM-DD"),
      cancel_reason: reason,
    }).then((res) => {
      setSubmitting(false);

      if (res?.code === 1) {
        getDetails();
        toast.success(res?.message);
        setShowCancelClassModal(false);
        setDate("");
        setTime("");
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  // Sorting function
  const sortedData = (students) => {
    if (!students) return [];

    const sortedStudents = [...students];
    sortedStudents.sort((a, b) => {
      const aKey = a[sortConfig.key];
      const bKey = b[sortConfig.key];
      if (typeof aKey === "string" && typeof bKey === "string") {
        return sortConfig.direction === "ascending"
          ? aKey.localeCompare(bKey)
          : bKey.localeCompare(aKey);
      }

      if (aKey < bKey) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (aKey > bKey) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });

    return sortedStudents;
  };

  // Function to handle column header click
  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  if (!detail) {
    return (
      <article class="col-lg-9">
        <Loader />
      </article>
    );
  } else {
    return (
      <article class="col-lg-9">
        <div class="article-body store-bd-gy">
          <div class="row align-items-center col-rever">
            <BackButton />

            <div class="col-sm-12 col-md-12 col-lg-12 mb-3 text-center">
              <h3>Register Details</h3>
            </div>

            <div className="row detailFIlterIcons align-items-baseline">
              <div className="col-sm-12 col-md-7 col-lg-7">
                <div className="changeAndPrint1 ">
                  <div
                    className={
                      register_for === "event" && data?.level_details
                        ? "mb-4"
                        : "d-none"
                    }
                  >
                    {register_for === "event" && data?.level_details && (
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="theme-color px-2 fw-bold">
                          Levels:{" "}
                        </label>{" "}
                        <select
                          className="form-control w-100"
                          value={levelId}
                          onChange={(e) => {
                            localStorage.setItem("level",e.target.value)
                            SetLevelId(e.target.value)
                            //dispatch(changeLevel(e.target.value));
                          }}
                        >
                          <option value="">Select Level</option>
                          {data?.levels?.map((item, i) => (
                            <option key={i} value={item?.id}>
                              {item?.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                  </div>
                  <div className="mb-4">
                    {" "}
                    <button
                      className="btn btn-view btn-accept ms-0"
                      onClick={() => {
                        navigate(`/registered-members/${id}/${data?.name}`);
                      }}
                    >
                      All Students
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-5 col-lg-5">
                <div className="changeAndPrint">
                  {register_for === "class" && (
                    <button
                      className="btn btn-view btn-accept ms-0"
                      disabled={isCancelledClass === false || submitting}
                      onClick={() => {
                        if (isCancelledClass === true) {
                          return;
                        }
                        setShowCancelClassModal(!showCancelClassModal);
                      }}
                    >
                      {isCancelledClass === true
                        ? "Class Cancelled"
                        : "Cancel Class"}
                    </button>
                  )}
                  {register_for === "class" ? (
                    <PrintComponent
                      data={data}
                      date={date}
                      time={time}
                      sortedData={sortedData}
                    />
                  ) : register_for === "event" ? (
                    <PrintEventComponent data={data} sortedData={sortedData} />
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5 px-md-5">
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-5">
              <div class="bg-white p-4 rounded shadow">
                <div class="eventResiterContainer">
                  <div class="">
                    <div class="event-box-flex align-items-normal">
                      <span>
                        <img
                          src={
                            data?.image?.includes("http")
                              ? data?.image
                              : "assets/images/headerlogo.png"
                          }
                          class="event-img"
                          alt=""
                        />
                      </span>
                      <span>
                        <h4>{data?.name || "NA"}</h4>
                        <p className="mb-0">
                          <label className="fw-bold theme-color">
                            Discipline:
                          </label>{" "}
                          {data?.discipline_details?.name}
                        </p>
                        <p className="mb-0">
                          <label className="fw-bold theme-color">
                            Teacher Name:
                          </label>{" "}
                          {register_for === "class"
                            ? data?.assigned_teacher?.teacher_details?.full_name
                            : register_for === "event"
                            ? data?.teacher_details?.full_name
                            : "NA"}
                        </p>
                        {register_for === "event" && data?.level_details ? (
                          <p className="fw-bold theme-color">
                            <label>Level: </label>{" "}
                            <span>{data?.level_details?.name}</span>
                          </p>
                        ) : null}
                        <p class="mb-0 registerInfoGrid">
                          {data?.date && data?.start_time && (
                            <>
                              <span>
                                <img
                                  src="assets/images/Date-of-Birth.png"
                                  class="evt-dtl-icon"
                                  alt=""
                                />{" "}
                                {moment(data?.date).format("DD MMM YYYY")}
                              </span>
                              <span>
                                <img
                                  src="assets/images/time.png"
                                  class="evt-dtl-icon"
                                  alt=""
                                />{" "}
                                <label>Event time: </label>{" "}
                                {moment(data?.start_time, "hh:mm:ss").format(
                                  "hh:mm a"
                                )}
                              </span>
                            </>
                          )}

                          {data?.level_details?.time && (
                            <span>
                              <img
                                src="assets/images/time.png"
                                class="evt-dtl-icon"
                                alt=""
                              />{" "}
                              <label>Level time: </label>{" "}
                              {moment(
                                data?.level_details?.time,
                                "hh:mm:ss"
                              ).format("hh:mm a")}
                            </span>
                          )}
                          <span>
                            <img
                              src="assets/images/address.png"
                              class="evt-dtl-icon"
                              alt=""
                            />
                            {data?.school_details
                              ? `${data?.school_details?.name}, ${data?.school_details?.address}`
                              : "NA"}
                          </span>
                          <span>
                            <img
                              src="assets/images/total-seats.png"
                              class="evt-dtl-icon"
                              alt=""
                            />
                            {register_for === "class"
                              ? data?.total_seats
                              : data?.age_group?.toLowerCase() === "both"
                              ? `Adult | Child`
                              : data?.age_group || "NA"}
                          </span>
                        </p>
                      </span>
                    </div>
                  </div>
                  <div className=" position-relative">
                    <div class="event-price registerEventPrice reg-evt">
                      <div
                        onClick={toggle}
                        class="btn btn-view mb-3 btn-accept"
                      >
                        Add a New Student in the {register_for}
                      </div>
                      <div class="text-xl-end">
                        {register_for === "class" ? (
                          <>
                            {data?.adult_price !== "0" && data?.adult_price && (
                              <>
                                {" "}
                                Adult:{" "}
                                <i
                                  class="fa fa-gbp"
                                  aria-hidden="true"
                                ></i>{" "}
                                {data?.adult_price || "NA"}
                              </>
                            )}
                            {data?.child_price !== "0" && data?.child_price && (
                              <>
                                {" "}
                                Child:{" "}
                                <i
                                  class="fa fa-gbp"
                                  aria-hidden="true"
                                ></i>{" "}
                                {data?.child_price}
                              </>
                            )}
                          </>
                        ) : register_for === "event" &&
                          data?.levels?.length === 0 &&
                          data?.age_group?.toLowerCase() === "both" ? (
                          <>
                            Child: <i class="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {data?.child_price || "NA"} Adult:{" "}
                            <i class="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {data?.adult_price || "NA"}
                          </>
                        ) : register_for === "event" &&
                          data?.levels?.length === 0 &&
                          data?.age_group?.toLowerCase() === "child" ? (
                          <>
                            <i class="fa fa-gbp" aria-hidden="true"></i>
                            {data?.child_price || "NA"}
                          </>
                        ) : register_for === "event" &&
                          data?.levels?.length === 0 &&
                          data?.age_group?.toLowerCase() === "adult" ? (
                          <>
                            <i class="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {data?.adult_price || "NA"}
                          </>
                        ) : register_for === "event" &&
                          data?.levels?.length > 0 &&
                          data?.age_group?.toLowerCase() === "both" ? (
                          <>
                            Child: <i class="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {data?.level_details?.child_price || "NA"} Adult:{" "}
                            <i class="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {data?.level_details?.adult_price || "NA"}
                          </>
                        ) : register_for === "event" &&
                          data?.levels?.length > 0 &&
                          data?.age_group?.toLowerCase() === "child" ? (
                          <>
                            <i class="fa fa-gbp" aria-hidden="true"></i>
                            {data?.level_details?.child_price || "NA"}
                          </>
                        ) : register_for === "event" &&
                          data?.levels?.length > 0 &&
                          data?.age_group?.toLowerCase() === "adult" ? (
                          <>
                            <i class="fa fa-gbp" aria-hidden="true"></i>
                            {data?.level_details?.adult_price || "NA"}
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
              <div class="row mt-3">
                <div class="col-sm-12 d-xl-flex justify-content-between align-items-baseline">
                  <ul
                    class="nav nav-pills group-nav mt-0 mb-3"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li class="nav-item" role="presentation">
                      <button
                        class={tab === "all" ? "nav-link active" : "nav-link"}
                        onClick={() => {
                          setTab("all");
                        }}
                        id="pills-all-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-all"
                        type="button"
                        role="tab"
                        aria-controls="pills-all-tab"
                        aria-selected="true"
                      >
                        All
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class={
                          tab === "Present" ? "nav-link active" : "nav-link"
                        }
                        onClick={() => {
                          setTab("Present");
                        }}
                        id="pills-present-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-present"
                        type="button"
                        role="tab"
                        aria-controls="pills-present"
                        aria-selected="true"
                      >
                        present
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class={
                          tab === "Absent" ? "nav-link active" : "nav-link"
                        }
                        onClick={() => {
                          setTab("Absent");
                        }}
                        id="pills-absent-tab"
                        data-bs-toggle="pill"
                        data-bs-target="#pills-absent"
                        type="button"
                        role="tab"
                        aria-controls="pills-absent"
                        aria-selected="false"
                      >
                        absent
                      </button>
                    </li>
                  </ul>

                  {register_for === "class" && (
                    <div className="datesContainer mb-xl-0 mb-3 gap-3">
                      <div className="form-group selectAreaCode">
                        <div className="input-container">
                          <Select
                            options={allTimeSlots || undefined}
                            getOptionLabel={(option) =>
                              `${moment(option.date).format("DD MMM YYYY")} ${moment(option.start_time, "hh:mm:ss").format("h:mm")} to ${moment(option.end_time, "hh:mm:ss").format("h:mm a")}`
                            }
                            styles={{
                              ...style,
                              container: (provided) => ({
                                ...provided,
                                minWidth: "500px",
                                backgroundImage: "none",
                                paddingRight: "2px",
                                borderRadius: "10px",
                              }),
                            }}
                            getOptionValue={(option) => option}
                            className="pl-5 form-select"
                            value={time || undefined}
                            onChange={(val) => {
                              setTime(val);
                              setDate(val);
                            }}
                            placeholder="Select time slot"
                          />
                          <img
                            src="assets/images/event-name.png"
                            className="input-img inputImage"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div class="col-sm-12">
                  <div class="tab-content" id="pills-tab">
                    <div
                      class={
                        tab === "all"
                          ? "tab-pane fade show active"
                          : "tab-pane fade"
                      }
                      id="pills-all"
                      role="tabpanel"
                      aria-labelledby="pills-all-tab"
                    >
                      <div class="table-responsive text-center">
                        <table class="table storetable">
                          <thead class="text-center">
                            <tr>
                              <th scope="col">
                                full name{" "}
                                <BiSort
                                  size={20}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("first_name")}
                                />
                              </th>
                              {/* <th scope="col">full address</th> */}
                              <th scope="col">membership</th>
                              <th scope="col">membership level</th>
                              <th scope="col">Actions</th>
                            </tr>
                            <tr class="border-0 bg-none invisible">
                              <td class="border-0 bg-none"></td>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <tr>
                                <td colSpan={5}>
                                  <Loader />
                                </td>
                              </tr>
                            ) : data?.student_list?.pending_student?.length >
                              0 ? (
                              sortedData(
                                data?.student_list?.pending_student
                              )?.map((student, i) => (
                                <tr key={i}>
                                  <td
                                    onClick={() => {
                                      navigate(`/student/${student?.id}`);
                                    }}
                                    className="cursor-pointer"
                                  >
                                    <span>{student?.first_name} {student?.last_name}</span>
                                    {student?.wallet_amount < 0 && (
                                      <p className="text-danger font-weight-bold">
                                      There is debt!<b style={{ marginLeft: "10px" }}>{student?.wallet_amount}</b>
                                    </p>
                                    )}
                                    
                                  </td>
                                  {/* <td>
                                      {student?.parent_address
                                        ? `${
                                            student?.parent_address
                                              ?.property_number
                                          }, ${
                                            student?.parent_address
                                              ?.property_name
                                              ? `${student?.parent_address?.property_name}, `
                                              : ""
                                          } ${
                                            student?.parent_address
                                              ?.street_number
                                          }, ${
                                            student?.parent_address?.town
                                          }, ${
                                            student?.parent_address?.country
                                          }-${
                                            student?.parent_address?.postal_code
                                          }`
                                        : "NA"}
                                    </td> */}
                                  <td>
                                    {student?.membership_details
                                      ? "Active"
                                      : "Trail"}
                                  </td>
                                  <td>
                                    {" "}
                                    {student?.membership_details
                                      ?.membership_details?.name || "NA"}
                                  </td>
                                  <td>
                                    <button
                                      className="btn mx-1 attendanceButton"
                                      type="button"
                                      onClick={() => {
                                        StudentAttendance({
                                          dataa: student,
                                          status: "Present",
                                        });
                                      }}
                                      disabled={
                                        student?.attendane_status?.toLowerCase() ===
                                        "present"
                                      }
                                    >
                                      Mark Present
                                    </button>
                                    <button
                                      className="btn mx-1 attendanceButton"
                                      type="button"
                                      onClick={() => {
                                        StudentAttendance({
                                          dataa: student,
                                          status: "Absent",
                                        });
                                      }}
                                      disabled={
                                        student?.attendane_status?.toLowerCase() ===
                                        "absent"
                                      }
                                    >
                                      Mark Absent
                                    </button>
                                    {register_for === "class" ? (
                                      <button
                                        className="btn mx-1 attendanceButton"
                                        type="button"
                                        disabled={
                                          student?.attendane_status
                                            ? true
                                            : false
                                        }
                                        onClick={() => {
                                          setChangeClassForStudentData({
                                            studentId: student?.id,
                                            student_type: student?.student_type,
                                            trialAccountStatus:
                                              student?.membership_details
                                                ? "3"
                                                : "1",
                                            time_slot_for:
                                              student?.student_type,

                                            adult_price: data?.adult_price,
                                            child_price: data?.child_price,
                                            teacherId:
                                              data?.assigned_teacher
                                                ?.teacher_details?.id,
                                            schoolId: data?.school_details?.id,
                                            old_booking_student_id:
                                              student?.old_booking_student_id,
                                            userId:
                                              student?.parent_address?.userId,
                                          });
                                          handleShow();
                                        }}
                                      >
                                        Change Class
                                      </button>
                                    ) : (
                                      <button
                                        className="btn mx-1 attendanceButton"
                                        type="button"
                                        onClick={() => {
                                          setChangeEventForStudentData({
                                            studentId: student?.id,
                                            student_type: student?.student_type,
                                            trialAccountStatus:
                                              student?.membership_details
                                                ? "3"
                                                : "1",
                                            time_slot_for:
                                              student?.student_type,

                                            adult_price:
                                              student?.membership_details
                                                ?.membership_details
                                                ?.adult_price,
                                            child_price: data?.child_price,
                                            teacherId:
                                              data?.teacher_details?.id,
                                            schoolId: data?.school_details?.id,
                                            old_booking_student_id:
                                              student?.old_booking_student_id,
                                            userId:
                                              student?.parent_address?.userId,
                                            age_group: data?.age_group,
                                            price:
                                              student?.membership_details
                                                ?.price,
                                          });
                                          handleShow();
                                        }}
                                      >
                                        Change Event
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <td colSpan={6}>No student found.</td>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div
                      class={
                        tab === "Present"
                          ? "tab-pane fade show active"
                          : "tab-pane fade"
                      }
                      id="pills-present"
                      role="tabpanel"
                      aria-labelledby="pills-present-tab"
                    >
                      <div class="table-responsive text-center">
                        <table class="table storetable">
                          <thead class="text-center">
                            <tr>
                              <th scope="col">
                                full name{" "}
                                <BiSort
                                  size={20}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("first_name")}
                                />
                              </th>
                              {/* <th scope="col">full address</th> */}
                              <th scope="col">membership</th>
                              <th scope="col">membership level</th>
                              <th scope="col">Actions</th>
                            </tr>
                            <tr class="border-0 bg-none invisible">
                              <td class="border-0 bg-none"></td>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <td colSpan={5}>
                                <Loader />
                              </td>
                            ) : data?.student_list?.present_student?.length >
                              0 ? (
                              sortedData(
                                data?.student_list?.present_student
                              )?.map((student, i) => (
                                <tr key={i}>
                                  <td
                                    onClick={() => {
                                      navigate(`/student/${student?.id}`);
                                    }}
                                  >
                                     <span>{student?.first_name} {student?.last_name}</span>
                                    {student?.wallet_amount < 0 && (
                                      <p className="text-danger font-weight-bold">
                                      There is debt!<b style={{ marginLeft: "10px" }}>{student?.wallet_amount}</b>
                                    </p>
                                    )}
                                  </td>
                                  {/* <td>
                                      {student?.parent_address
                                        ? `${
                                            student?.parent_address
                                              ?.property_number
                                          }, ${
                                            student?.parent_address
                                              ?.property_name
                                              ? `${student?.parent_address?.property_name}, `
                                              : ""
                                          } ${
                                            student?.parent_address
                                              ?.street_number
                                          }, ${
                                            student?.parent_address?.town
                                          }, ${
                                            student?.parent_address?.country
                                          }-${
                                            student?.parent_address?.postal_code
                                          }`
                                        : "NA"}
                                    </td> */}
                                  <td>
                                    {student?.membership_details
                                      ? "Active"
                                      : "Trail"}
                                  </td>
                                  <td>
                                    {" "}
                                    {student?.membership_details
                                      ?.membership_details?.name || "NA"}
                                  </td>
                                  <td>
                                    <button
                                      className="btn mx-1 attendanceButton"
                                      type="button"
                                      onClick={() => {
                                        StudentAttendance({
                                          dataa: student,
                                          status: "Absent",
                                        });
                                      }}
                                    >
                                      Mark Absent
                                    </button>
                                    {register_for === "class" ? (
                                      <button
                                        className="btn mx-1 attendanceButton"
                                        type="button"
                                        onClick={() => {
                                          setChangeClassForStudentData({
                                            studentId: student?.id,
                                            student_type: student?.student_type,
                                            trialAccountStatus:
                                              student?.membership_details
                                                ? "3"
                                                : "1",
                                            time_slot_for:
                                              student?.student_type,

                                            adult_price: data?.adult_price,
                                            child_price: data?.child_price,
                                            teacherId:
                                              data?.assigned_teacher
                                                ?.teacher_details?.id,
                                            schoolId: data?.school_details?.id,
                                            old_booking_student_id:
                                              student?.old_booking_student_id,
                                            userId: student?.parent_address?.id,
                                          });
                                          handleShow();
                                        }}
                                      >
                                        Change Class
                                      </button>
                                    ) : (
                                      <button
                                        className="btn mx-1 attendanceButton"
                                        type="button"
                                        onClick={() => {
                                          setChangeEventForStudentData({
                                            studentId: student?.id,
                                            student_type: student?.student_type,
                                            trialAccountStatus:
                                              student?.membership_details
                                                ? "3"
                                                : "1",
                                            time_slot_for:
                                              student?.student_type,

                                            adult_price:
                                              student?.membership_details
                                                ?.membership_details
                                                ?.adult_price,
                                            child_price: data?.child_price,
                                            teacherId:
                                              data?.teacher_details?.id,
                                            schoolId: data?.school_details?.id,
                                            old_booking_student_id:
                                              student?.old_booking_student_id,
                                            userId:
                                              student?.parent_address?.userId,
                                            age_group: data?.age_group,
                                            price:
                                              student?.membership_details
                                                ?.price,
                                          });
                                          handleShow();
                                        }}
                                      >
                                        Change Event
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <td colSpan={6}>No student found.</td>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div
                      class={
                        tab === "Absent"
                          ? "tab-pane fade show active"
                          : "tab-pane fade"
                      }
                      id="pills-absent"
                      role="tabpanel"
                      aria-labelledby="pills-absent-tab"
                    >
                      <div class="table-responsive text-center">
                        <table class="table storetable">
                          <thead class="text-center">
                            <tr>
                              <th scope="col">
                                full name{" "}
                                <BiSort
                                  size={20}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleSort("first_name")}
                                />
                              </th>
                              {/* <th scope="col">full address</th> */}
                              <th scope="col">membership</th>
                              <th scope="col">membership level</th>
                              <th scope="col">Actions</th>
                            </tr>
                            <tr class="border-0 bg-none invisible">
                              <td class="border-0 bg-none"></td>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <td colSpan={5}>
                                <Loader />
                              </td>
                            ) : data?.student_list?.absent_student?.length >
                              0 ? (
                              sortedData(
                                data?.student_list?.absent_student
                              )?.map((student, i) => (
                                <tr key={i}>
                                  <td
                                    onClick={() => {
                                      navigate(`/student/${student?.id}`);
                                    }}
                                  >
                                     <span>{student?.first_name} {student?.last_name}</span>
                                    {student?.wallet_amount < 0 && (
                                      <p className="text-danger font-weight-bold">
                                      There is debt!<b style={{ marginLeft: "10px" }}>{student?.wallet_amount}</b>
                                    </p>
                                    )}
                                  </td>
                                  {/* <td>
                                      {student?.parent_address
                                        ? `${
                                            student?.parent_address
                                              ?.property_number
                                          }, ${
                                            student?.parent_address
                                              ?.property_name
                                              ? `${student?.parent_address?.property_name}, `
                                              : ""
                                          } ${
                                            student?.parent_address
                                              ?.street_number
                                          }, ${
                                            student?.parent_address?.town
                                          }, ${
                                            student?.parent_address?.country
                                          }-${
                                            student?.parent_address?.postal_code
                                          }`
                                        : "NA"}
                                    </td> */}
                                  <td>
                                    {student?.membership_details
                                      ? "Active"
                                      : "Trail"}
                                  </td>
                                  <td>
                                    {" "}
                                    {student?.membership_details
                                      ?.membership_details?.name || "NA"}
                                  </td>
                                  <td>
                                    <button
                                      className="btn mx-1 attendanceButton"
                                      type="button"
                                      onClick={() => {
                                        StudentAttendance({
                                          dataa: student,
                                          status: "Present",
                                        });
                                      }}
                                    >
                                      Mark Present
                                    </button>
                                    {register_for === "class" ? (
                                      <button
                                        className="btn mx-1 attendanceButton"
                                        type="button"
                                        onClick={() => {
                                          setChangeClassForStudentData({
                                            studentId: student?.id,
                                            student_type: student?.student_type,
                                            trialAccountStatus:
                                              student?.membership_details
                                                ? "3"
                                                : "1",

                                            time_slot_for:
                                              student?.student_type,

                                            adult_price: data?.adult_price,
                                            child_price: data?.child_price,
                                            teacherId:
                                              data?.assigned_teacher
                                                ?.teacher_details?.id,
                                            schoolId: data?.school_details?.id,
                                            old_booking_student_id:
                                              student?.old_booking_student_id,
                                            userId: student?.parent_address?.id,
                                          });
                                          handleShow();
                                        }}
                                      >
                                        Change Class
                                      </button>
                                    ) : (
                                      <button
                                        className="btn mx-1 attendanceButton"
                                        type="button"
                                        onClick={() => {
                                          setChangeEventForStudentData({
                                            studentId: student?.id,
                                            student_type: student?.student_type,
                                            trialAccountStatus:
                                              student?.membership_details
                                                ? "3"
                                                : "1",
                                            time_slot_for:
                                              student?.student_type,

                                            adult_price:
                                              student?.membership_details
                                                ?.membership_details
                                                ?.adult_price,
                                            child_price: data?.child_price,
                                            teacherId:
                                              data?.teacher_details?.id,
                                            schoolId: data?.school_details?.id,
                                            old_booking_student_id:
                                              student?.old_booking_student_id,
                                            userId:
                                              student?.parent_address?.userId,
                                            age_group: data?.age_group,
                                            price:
                                              student?.membership_details
                                                ?.price,
                                          });
                                          handleShow();
                                        }}
                                      >
                                        Change Event
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <td colSpan={6}>No student found.</td>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddNewStudent
          id={id}
          submitting={addStudentSubmitting}
          setSubmitting={setAddStudentSubmitting}
          show={show}
          handleShow={toggle}
          company_id={data?.company_id}
          availableDates={availableDates}
          handleAddStudentToRegister={(_student, _time, _date, _class_type) => {
            addStudentToRegister(_student, _time, _date, _class_type);
          }}
          availableTimeSlots={availableTimeSlots}
          allTimeSlots={allTimeSlots}
          register_for={register_for}
          // students={
          //   register_for === "class"
          //     ? studentForClass
          //     : register_for === "event"
          //     ? studentForEvent
          //     : []
          // }
          class_type={
            register_for === "class"
              ? data?.class_type
              : register_for === "event"
              ? data?.age_group
              : ""
          }
        />
        {changeClassForStudentData && (
          <ChangeStudentClass
            submitting={changeClassSubmitting}
            show={showClass}
            handleShow={handleShow}
            class_type={changeClassForStudentData?.time_slot_for}
            id={id}
            setChangeClassForStudentData={(
              val,
              dates,
              selectedClass,
              start_time,
              end_time,
              time_slot_id
            ) => {
              console.log(selectedClass, "Selected class");
              setChangeClassForStudentData((prev) => {
                return {
                  ...prev,
                  classId: val,
                };
              });

              handleChangeClass({
                ...changeClassForStudentData,
                classId: val,
                date: dates.date,
                start_time: dates?.start_time,
                end_time: dates?.end_time,
                time_slot_id: dates?.time_slot_id,
                total_amount:
                  String(changeClassForStudentData?.trialAccountStatus) === "1"
                    ? changeClassForStudentData?.time_slot_for.toLowerCase() ===
                        "child" && selectedClass?.free_class_charge
                      ? selectedClass?.free_class_charge
                      : changeClassForStudentData?.time_slot_for.toLowerCase() ===
                          "adult" && selectedClass?.free_class_charge_adult
                      ? selectedClass?.free_class_charge_adult
                      : 0
                    : changeClassForStudentData?.time_slot_for.toLowerCase() ===
                        "child" && selectedClass?.child_price
                    ? selectedClass?.child_price
                    : changeClassForStudentData?.time_slot_for.toLowerCase() ===
                        "adult" && selectedClass?.adult_price
                    ? selectedClass?.adult_price
                    : 0,
              });
            }}
          />
        )}

        <Cancel
          submitting={submitting}
          setSubmitting={setSubmitting}
          show={showCancelClassModal}
          handleShow={() => {
            setShowCancelClassModal(!showCancelClassModal);
          }}
          page={"Class"}
          handleCancel={handleCancelClass}
        />

        {changeEventForStudentData && (
          <ChangeStudentEventComponent
            show={showClass}
            handleShow={handleShow}
            submitting={changeEventSubmitting}
            // class_type={changeEventForStudentData?.time_slot_for}
            changeEventForStudentData={changeEventForStudentData}
            setChangeEventForStudentData={setChangeEventForStudentData}
            id={id}
            getDetails={getDetails}
            setChangeEventSubmitting={setChangeEventSubmitting}

            // changeEventForStudentData={(
            //   val,
            //   selectedLevel,
            //   selectedEvent,
            //   dates,
            //   start_time,
            //   end_time,
            //   time_slot_id
            // ) => {
            //   setChangeEventForStudentData((prev) => {
            //     return {
            //       ...prev,
            //       eventId: val,
            //     };
            //   });

            //   handleChangeEvent({
            //     ...changeEventForStudentData,
            //     eventId: val,
            //     levelId: selectedLevel,
            //     date: dates.date,
            //     // start_time: dates?.start_time,
            //     // end_time: dates?.end_time,
            //     // time_slot_id: dates?.time_slot_id,
            //     total_amount:
            //       changeEventForStudentData?.time_slot_for.toLowerCase() ===
            //       "child"
            //         ? selectedEvent?.child_price
            //         : changeEventForStudentData?.time_slot_for.toLowerCase() ===
            //           "adult"
            //         ? selectedEvent?.adult_price
            //         : 0,
            //   });
            // }}
          />
        )}
      </article>
    );
  }
}

export default ViewRegister;
